import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgErrorTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 34,
	height: 29,
	viewBox: "0 0 34 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.5 28.5L17 0L33.5 28.5H0.5ZM17 24C17.425 24 17.7815 23.856 18.0695 23.568C18.3575 23.28 18.501 22.924 18.5 22.5C18.5 22.075 18.356 21.719 18.068 21.432C17.78 21.145 17.424 21.001 17 21C16.575 21 16.219 21.144 15.932 21.432C15.645 21.72 15.501 22.076 15.5 22.5C15.5 22.925 15.644 23.2815 15.932 23.5695C16.22 23.8575 16.576 24.001 17 24ZM15.5 19.5H18.5V12H15.5V19.5Z",
		fill: "#FF3844"
	})
});
export default SvgErrorTriangle;
